import { render, staticRenderFns } from "./ProductionOrderList.vue?vue&type=template&id=01ca3632&scoped=true&"
import script from "./ProductionOrderList.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ProductionOrderList.vue?vue&type=style&index=0&id=01ca3632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ca3632",
  null
  
)

export default component.exports